var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_26",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m43.297,41.029c-.413,0-.825.309-1.031.722-.103.515-3.609,13.198.825,19.076,1.34,1.753,3.196,2.681,5.465,2.99v14.435h-3.712c-.619,0-1.031.413-1.031,1.031s.413,1.031,1.031,1.031h9.589c.619,0,1.031-.413,1.031-1.031s-.413-1.031-1.031-1.031h-3.712v-14.435c2.372-.206,4.227-1.238,5.568-2.99,4.434-5.877.928-18.56.722-19.076-.103-.413-.515-.722-1.031-.722h-12.682Zm11.961,2.063c.206.928.619,2.681.928,4.743-.515.206-1.238.309-2.165.309-1.547,0-2.372-.309-3.403-.722-1.031-.413-2.165-.928-4.125-.928-1.34,0-2.268.206-2.99.515.206-1.65.515-3.093.722-3.918h11.033Zm-.619,16.497c-1.134,1.443-2.681,2.165-4.846,2.165s-3.815-.722-4.949-2.165c-1.856-2.475-2.062-6.702-1.753-10.311.928-.413,1.753-.722,3.3-.722s2.372.309,3.403.722c1.031.413,2.165.928,4.125.928,1.031,0,1.753-.103,2.372-.309.309,3.505.103,7.32-1.65,9.692h0Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m90.212,7.106c-.515-.206-1.134,0-1.34.515l-7.527,15.569H18.655l-7.527-15.569c-.206-.515-.825-.722-1.34-.515-.515.206-.722.825-.515,1.34l7.733,15.983v63.825c0,.619.413,1.031,1.031,1.031h64.031c.619,0,1.031-.413,1.031-1.031V24.429l7.63-15.879c.206-.619,0-1.238-.515-1.444h0Zm-43.306,18.044h5.774v9.486h-5.774v-9.486Zm34.129,61.968H19.067V25.15h25.777v10.517c0,.619.413,1.031,1.031,1.031h7.836c.619,0,1.031-.413,1.031-1.031v-10.517s26.293,0,26.293,0v61.968Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }